import React, { useState, useEffect } from "react";

export default function FacebookML() {
  const images = [
    `${process.env.PUBLIC_URL}/Facebook-Market.png`,
    `${process.env.PUBLIC_URL}/Facebook-Market2.png`,
    `${process.env.PUBLIC_URL}/Facebook-Market3.png`,
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div
      className="min-h-screen flex flex-col bg-gray-900 text-white px-2 md:px-8 pt-20"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/Thailand.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Side-by-Side Section */}
      <div className="flex-grow flex md:flex-row items-stretch justify-center gap-12 px-8 pt-8 md:flex mb-20">
        {/* Slideshow Image Section */}
        <div className="w-full md:w-1/2 hidden md:flex justify-center items-stretch">
          <img
            src={images[currentImage]}
            alt="Facebook ML Analysis"
            className="w-full h-full rounded-2xl shadow-lg object-cover transition duration-1000"
          />
        </div>

        {/* Text Content Section */}
        <div className="bg-black/60 backdrop-blur-md p-8 rounded-2xl shadow-lg w-auto flex flex-col justify-center">
          <h1 className="text-3xl md:text-4xl font-bold text-purple-400 mb-6">Facebook Post ML Analysis</h1>
          <p className="text-gray-300 leading-relaxed text-lg my-6">
            Performed data clustering and PCA on Facebook post engagement data from Thai fashion retailers to identify key consumer behavior patterns.
          </p>
          <ul className="list-disc list-outside pl-6 text-gray-300 leading-relaxed text-md md:text-lg space-y-4">
            <li>Data Preprocessing: Cleaned and prepared 7,051 social media posts for clustering analysis.</li>
            <li>Modeling: Applied K-Means clustering and PCA to uncover seasonal engagement patterns and customer interest segments.</li>
            <li>Outlier Analysis: Identified statistical outliers for qualitative analysis and strategic business insights.</li>
            <li>Visualization: Generated clear and impactful visualizations using Matplotlib and Seaborn for business reporting.</li>
          </ul>
          <p className="text-gray-300 leading-relaxed text-lg mt-6">
            Provided actionable marketing insights to optimize campaign effectiveness and customer targeting.
          </p>
        </div>
      </div>
    </div>
  );
}